<template>
  <BaseTableWrapper>
    <template #top-buttons>
      <div class="float-right mb-1">
        <router-link tag="button" :to="{ name: 'EXCMCyclicTaskCreate' }" class="btn btn-sm btn-primary">{{ $t('buttons.create') }}</router-link>
      </div>
    </template>
    <template #filtering></template>
    <template #body>
      <div v-if="isLoading">
        <Loader></Loader>
      </div>
      <div v-else-if="!isLoading && items.length < 1">
        {{ $t('views.excmcyclictask.list.noTasks') }}
      </div>
      <div v-else>
        <table class="table table-sm table-responsive-md table-striped table-hover">
          <thead>
            <tr>
              <th>{{ $t('views.excmcyclictask.list.agreement') }}</th>
              <th>{{ $t('views.excmcyclictask.list.contractor') }}</th>
              <th>{{ $t('views.excmcyclictask.list.taskType') }}</th>
              <th>{{ $t('views.excmcyclictask.list.dateFrom') }}</th>
              <th>{{ $t('views.excmcyclictask.list.dateTo') }}</th>
              <th class="text-center">{{ $t('views.excmcyclictask.list.daysInterval') }}</th>
              <th style="width: 5%"></th>
            </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item['@id']">
            <td>
              {{ item.agreement.agreementNumber || '' }}
            </td>
            <td>
              {{ item.agreement.company.firmname1 || '' }}
            </td>
            <td>
              {{ item.taskType.title }}
            </td>
            <td>
              {{ $moment(item.dateFrom).format('YYYY-MM-DD') }}
            </td>
            <td>
              {{ $moment(item.dateTo).format('YYYY-MM-DD') }}
            </td>
            <td class="text-center">
              {{ item.daysInterval }}
            </td>
            <td>
              <router-link v-if="false" tag="button" :to="{ name: 'EXCMCyclicTaskShow', params: { id: item['@id'] } }" class="btn btn-sm btn-link fa fa-search fa-lg"></router-link>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="view">
        <Pagination :view="view" @getPage="getPage($event)"></Pagination>
      </div>
    </template>
  </BaseTableWrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../Layout/Loader'
import Pagination from '../../Layout/Pagination'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  computed: mapGetters({
    deletedItem: 'excmcyclictask/del/deleted',
    error: 'excmcyclictask/list/error',
    items: 'excmcyclictask/list/items',
    isLoading: 'excmcyclictask/list/isLoading',
    view: 'excmcyclictask/list/view'
  }),

  components: {
    Loader,
    Pagination,
    BaseTableWrapper
  },

  created () {
    this.getPage()
  },
  beforeCreate () {
    checkPagePermission('tasks', 'EXCMCyclicTaskList')
  },
  methods: mapActions({
    getPage: 'excmcyclictask/list/default'
  })
}
</script>
